





















// @ is an alias to /src
import Vue from "vue";

export default class Login extends Vue {
  public async login(e: Event): Promise<void> {
    try {
      const payload = {
        username: (e.target as HTMLFormElement).username.value,
        password: (e.target as HTMLFormElement).password.value
      };
      const response = await fetch(process.env.VUE_APP_API_URL + "/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (response.status === 200) {
        const result = await response.json();
        this.$store.dispatch("setUser", result.data);
        this.$router.push("/");
      }
    } catch (err) {
      console.error(err);
    }
  }

  public logout(): void {
    this.$store.commit("clearUser");
  }
}
